import { gsap } from "gsap";

// Cardinal spline - a uniform Catmull-Rom spline with a tension option
function cardinal(data, closed, tension = 1) {

  if (data.length < 1) return "M0 0";
  // if (tension == null) tension = 1;
  // eslint-disable-next-line no-param-reassign
  tension = tension ?? 1

  const size = data.length - (closed ? 0 : 1);
  let path = `M${  data[0].x  } ${  data[0].y  } C`;

  for (let i = 0; i < size; i++) {

    let p0; let p1; let p2; let p3;

    if (closed) {
      p0 = data[(i - 1 + size) % size];
      p1 = data[i];
      p2 = data[(i + 1) % size];
      p3 = data[(i + 2) % size];

    } else {
      p0 = i === 0 ? data[0] : data[i - 1];
      p1 = data[i];
      p2 = data[i + 1];
      p3 = i === size - 1 ? p2 : data[i + 2];
    }

    const x1 = p1.x + (p2.x - p0.x) / 6 * tension;
    const y1 = p1.y + (p2.y - p0.y) / 6 * tension;

    const x2 = p2.x - (p3.x - p1.x) / 6 * tension;
    const y2 = p2.y - (p3.y - p1.y) / 6 * tension;

    path += ` ${  x1  } ${  y1  } ${  x2  } ${  y2  } ${  p2.x  } ${  p2.y}`;
  }

  return closed ? `${path  }z` : path;
}

function createFigure(options) {
  options.pause = true;

  const points = [];

  const path = options.element.isArray || options.element instanceof NodeList ? [...options.element] : [options.element];
  const slice = (Math.PI * 2) / options.numPoints;
  const startAngle = gsap.utils.random(0, 360);

  const tl = gsap.timeline({
    onUpdate: () => {
      // eslint-disable-next-line no-unused-expressions
      !options.pause && path.forEach(el => el.setAttribute("d", cardinal(points, true, 0)))
    }
  });

  for (let i = 0; i < options.numPoints; i++) {
    const moveAngle = gsap.utils.random(0, 360);

    const angle = startAngle + i * slice;
    const duration = gsap.utils.random(options.minDuration, options.maxDuration);

    const point = {
      x: options.centerX + Math.cos(angle) * options.minRadius + Math.cos(moveAngle + 180) * options.minRadius,
      y: options.centerY + Math.sin(angle) * options.minRadius + Math.sin(moveAngle + 180) * options.minRadius,
    };

    const tween = gsap.to(point, {
      duration,
      x: options.centerX + Math.cos(angle) * options.maxRadius + Math.cos(moveAngle) * options.minRadius,
      y: options.centerY + Math.sin(angle) * options.maxRadius + Math.sin(moveAngle) * options.minRadius,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    tl.add(tween, -gsap.utils.random(0, duration));
    points.push(point);
  }

  const i = 0;
  const j = 1;
  [points[i], points[j]] = [points[j], points[i]];

  options.tl = tl;
  options.points = points;

  return options;
}

const waveObserver = (el, callback) => {
  const intersectionObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        callback(entry.isIntersecting)
      });
    },
    {
      rootMargin: "0px",
    }
  );

  intersectionObserver.observe(el);
}

document.querySelectorAll('.js-figures-card').forEach((card) => {
  let sprites = card.querySelectorAll('.moving-sprite');
  let figures = [];
  sprites.forEach((el) => {
    figures.push(createFigure({
      element: el,
      numPoints: 4,
      centerX: 0,
      centerY: 0,
      minRadius: 300 + Math.floor(Math.random() * 85),
      maxRadius: 500 + Math.floor(Math.random() * 150),
      minDuration: 40,
      maxDuration: 50,
    }));
  });
  waveObserver(card, (isIntersecting) => {
    figures.forEach(el => {
      el.pause = !isIntersecting;
    });
  });
});

const priceSection = document.querySelector('.section-price__list')
const priceWaves = [];
if (priceSection) {
  const priceCards = document.querySelectorAll('.price-card-wave')
  priceCards.forEach((el, index) => {
    if (window.innerWidth < 599) return;

    priceWaves.push(createFigure({
      element: el,
      numPoints: 4,
      centerX: 0,
      centerY: 0,
      minRadius: 300 + Math.floor(Math.random() * 85) + index * Math.floor(Math.random() * 3),
      maxRadius: 500 + Math.floor(Math.random() * 150) + index * Math.floor(Math.random() * 3),
      minDuration: 40,
      maxDuration: 50,
    }))
  })

  waveObserver(priceSection, (isIntersecting) => {
    priceWaves.forEach(el => {
      el.pause = !isIntersecting
    })
  })
}

const formSection = document.querySelector('.section-faq__form-wave')
const formWaves = [];

if (formSection) {
  const form = formSection.querySelectorAll('.form-wave')

  form.forEach((el, index) => {
    formWaves.push(createFigure({
      element: el,
      numPoints: 4,
      centerX: 0,
      centerY: 0,
      minRadius: 250 + Math.floor(Math.random() * 85) + index * Math.floor(Math.random() * 3),
      maxRadius: 300 + Math.floor(Math.random() * 150) + index * Math.floor(Math.random() * 3),
      minDuration: 20,
      maxDuration: 30,
    }))
  })

  waveObserver(formSection, (isIntersecting) => {
    formWaves.forEach(el => {
      el.pause = !isIntersecting
    })
  })
}
